import React, { useState } from "react";
import {
  MdArrowBack,
  MdCheckCircle,
  MdRadioButtonUnchecked,
} from "react-icons/md";
import { Link, useParams } from "react-router-dom";

const ProofOfInvestmentsCTR = () => {
  const { company_employee_id } = useParams();
  const [selectedRegime, setSelectedRegime] = useState("old"); // 'old' or 'new'

  // Static data for tax regime
  const taxRegimeData = {
    old: {
      name: "Old Tax Regime",
      totalTax: "₹93,600.00",
      particulars: [
        {
          section: "House Rent Paid Details",
          items: [
            {
              period: "Apr 2025 - Mar 2026",
              actualAmount: "₹1,20,000.00",
              perMonth: "₹10,000.00 / month",
              location: "Gorai",
              landlordName: "Ganesh",
              pan: "AADPG2854M",
              metro: "Metro",
            },
          ],
        },
        {
          section: "80C Investments",
          maxLimit: "₹1,50,000.00",
          items: [
            {
              name: "Children Tuition Fees",
              actualAmount: "₹2,00,000.00",
            },
            {
              name: "Senior Citizen Savings Scheme",
              actualAmount: "₹1,20,000.00",
            },
            {
              name: "Life Insurance Premium",
              actualAmount: "₹40,000.00",
            },
          ],
        },
        {
          section: "80D Exemptions",
          maxLimit: "₹1,00,000.00",
          items: [
            {
              name: "Medi Claim Policy for self, spouse, children for senior citizen - 80D",
              actualAmount: "₹60,000.00",
            },
          ],
        },
      ],
    },
    new: {
      name: "New Tax Regime",
      totalTax: "₹0.00",
      particulars: [],
    },
  };

  const selectedData = taxRegimeData[selectedRegime];

  const handleSubmit = () => {
    console.log("Submitting with regime:", selectedRegime);
    // Handle submit logic here
  };

  const handleCancel = () => {
    // Handle cancel logic here
    console.log("Cancelled");
  };

  return (
    <div className="w-[75%] p-6 mt-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Compare Tax Details
        </h1>
      </div>

      {/* Tax Regime Selection Cards */}
      <div className="grid grid-cols-2 gap-6 mb-8">
        {/* Old Tax Regime Card */}
        <div
          className={`relative bg-white p-6 rounded-lg border transition-all cursor-pointer flex flex-col justify-center
            ${
              selectedRegime === "old"
                ? "border-blue-500"
                : "border-[#E3E6EA] hover:shadow-md"
            }
          `}
          onClick={() => setSelectedRegime("old")}
        >
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center h-full">
              {selectedRegime === "old" ? (
                <MdCheckCircle className="w-5 h-5 text-blue-600" />
              ) : (
                <MdRadioButtonUnchecked className="w-5 h-5 text-gray-400" />
              )}
            </span>
            <div className="flex flex-col">
              <span className="text-[17px] font-semibold text-gray-900">
                Old Tax Regime
              </span>
              <span className="text-[15px] text-gray-500 font-medium mt-1">
                Total Tax :{" "}
                <span className="text-[15px] text-gray-900 font-medium">
                  {taxRegimeData.old.totalTax}
                </span>
              </span>
            </div>
          </div>
        </div>

        {/* New Tax Regime Card */}
        <div
          className={`relative bg-white p-6 rounded-lg border transition-all cursor-pointer flex flex-col justify-center
            ${
              selectedRegime === "new"
                ? "border-blue-500"
                : "border-[#E3E6EA] hover:shadow-md"
            }
          `}
          onClick={() => setSelectedRegime("new")}
        >
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center h-full">
              {selectedRegime === "new" ? (
                <MdCheckCircle className="w-5 h-5 text-blue-600" />
              ) : (
                <MdRadioButtonUnchecked className="w-5 h-5 text-gray-400" />
              )}
            </span>
            <div className="flex flex-col">
              <span className="text-[17px] font-semibold text-gray-900">
                New Tax Regime
              </span>
              <span className="text-[15px] text-gray-500 font-medium mt-1">
                Total Tax :{" "}
                <span className="text-[15px] text-gray-900 font-medium">
                  {taxRegimeData.new.totalTax}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Particulars Table */}
      <div className="bg-white mb-8">
        {/* Table Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex">
            <div className="w-3/5">
              <span className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
                PARTICULARS
              </span>
            </div>
            <div className="w-2/5 text-right">
              <span className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
                ACTUAL AMOUNT
              </span>
            </div>
          </div>
        </div>

        {/* Table Content */}
        <div className="divide-y divide-gray-200">
          {selectedData.particulars.length > 0 ? (
            <>
              {/* House Rent Paid Details */}
              <div className="pb-2 border-b border-gray-200">
                {/* Section Header */}
                <div className="flex w-full mb-2 px-6 pt-6">
                  <div className="w-3/5">
                    <span className="text-base font-semibold text-gray-900">
                      House Rent Paid Details
                    </span>
                  </div>
                </div>
                {/* Section Items */}
                <div className="flex w-full px-6 py-2">
                  <div className="w-3/5 text-gray-800 text-[15px]">
                    Apr 2025 - Mar 2026
                  </div>
                  <div className="w-2/5 flex flex-col items-end">
                    <span className="text-gray-900 text-[15px] font-medium">
                      ₹1,20,000.00
                    </span>
                    <span className="text-xs text-gray-400 font-normal">
                      (₹10,000.00 / month)
                    </span>
                  </div>
                </div>
                {/* Second row: location and landlord details */}
                <div className="flex w-full px-6">
                  <div className="w-3/5 flex flex-col gap-4 mt-2">
                    <div className="text-gray-800 text-[13px]">Gorai</div>
                    <div className="text-[13px]">
                      <span className="font-medium text-gray-400">Landlord Name</span>
                      <span className="text-gray-400"> :</span>
                      <span className="text-gray-800"> Ganesh</span>
                    </div>
                    <div className="text-[13px]">
                      <span className="font-medium text-gray-400">PAN</span>
                      <span className="text-gray-400"> :</span>
                      <span className="text-gray-800"> AADPG2854M</span>
                      <span className="text-gray-400"> • </span>
                      <span className="text-gray-800">Metro</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* 80C Investments */}
              <div className="p-6">
                <div className="flex mb-2">
                  <div className="w-3/5">
                    <span className="text-base font-semibold text-gray-900">
                      80C Investments
                    </span>
                    <span className="text-sm text-gray-500 ml-2">
                      (Max Limit : ₹1,50,000.00)
                    </span>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex">
                    <div className="w-3/5 text-gray-700">Children Tuition Fees</div>
                    <div className="w-2/5 text-right font-semibold text-gray-900">
                      ₹2,00,000.00
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-3/5 text-gray-700">Senior Citizen Savings Scheme</div>
                    <div className="w-2/5 text-right font-semibold text-gray-900">
                      ₹1,20,000.00
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-3/5 text-gray-700">Life Insurance Premium</div>
                    <div className="w-2/5 text-right font-semibold text-gray-900">
                      ₹40,000.00
                    </div>
                  </div>
                </div>
              </div>
              {/* 80D Exemptions */}
              <div className="p-6">
                <div className="flex mb-2">
                  <div className="w-3/5">
                    <span className="text-base font-semibold text-gray-900">
                      80D Exemptions
                    </span>
                    <span className="text-sm text-gray-500 ml-2">
                      (Max Limit : ₹1,00,000.00)
                    </span>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex">
                    <div className="w-3/5 text-gray-700">
                      Medi Claim Policy for self, spouse, children for senior citizen - 80D
                    </div>
                    <div className="w-2/5 text-right font-semibold text-gray-900">
                      ₹60,000.00
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="p-6 text-center text-gray-500">
              No particulars available for this tax regime
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between mt-8">
        <div className="flex gap-4">
          <button
            onClick={handleSubmit}
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors"
          >
            Save
          </button>
          <button
            onClick={handleCancel}
            className="px-6 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
        </div>
        <Link
          to={`/employee-details/${company_employee_id}/investments-and-proofs?tab=poi`}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium text-sm transition-colors"
        >
          <span className="text-lg">&#8592;</span>
          Edit Proof of Investments
        </Link>
      </div>
    </div>
  );
};

export default ProofOfInvestmentsCTR;
